export const VAT_0 = {
  label: '0%',
  value: 0.00,
};
export const VAT_6 = {
  label: '6%',
  value: 6.00,
};
export const VAT_12 = {
  label: '12%',
  value: 12.00,
};
export const VAT_25 = {
  label: '25%',
  value: 25.00,
};

export const DEFEAULT_VAT_OPTIONS = [VAT_0, VAT_6, VAT_12, VAT_25];

export const PRICE_UNIT_ST = {
  label: 'st',
  value: 'st',
};

export const PRICE_UNIT_L = {
  label: 'l',
  value: 'l',
};

export const PRICE_UNIT_DL = {
  label: 'dl',
  value: 'dl',
};

export const PRICE_UNIT_CL = {
  label: 'cl',
  value: 'cl',
};

export const PRICE_UNIT_ML = {
  label: 'ml',
  value: 'ml',
};

export const PRICE_UNIT_KG = {
  label: 'kg',
  value: 'kg',
};

export const PRICE_UNIT_HG = {
  label: 'hg',
  value: 'hg',
};

export const PRICE_UNIT_G = {
  label: 'g',
  value: 'g',
};

export const PRICE_UNIT_OPTIONS = [PRICE_UNIT_ST, PRICE_UNIT_L, PRICE_UNIT_DL, PRICE_UNIT_CL, PRICE_UNIT_ML, PRICE_UNIT_KG, PRICE_UNIT_HG, PRICE_UNIT_G];

export const FONT_SIZE_OPTIONS = [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
  28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
  56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83,
  84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99].map(option => ({ label: option, value: option }));

export const CODE_CHAR_LENGTH = 1;

export const CREATE_EXTRA_DATA = (data) => {
  let newData = { ...data };
  if (newData.hasOwnProperty('SpecialFunctionType')) {
    newData.SpecialFunctionTypeId = newData.SpecialFunctionType;
  }
  return newData;
};

export const CREATE_VAT_OPTIONS = (vat) => {
  return vat.map(item => {
    return {
      label: `${item}%`,
      value: item,
    };
  });
};

export const CREATE_DICTIONARIES = (dictionaries) => {
  return dictionaries.map(item => {
    return {
      label: item.ListName,
      value: item.ListId,
    };
  });
};